export const SELECTORS = {
  OPTION: 'js-navigation-desktop-dropdown-link',
  SECTION: 'js-navigation-desktop-dropdown'
};
